<script>
    import { onMount } from "svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import {
        ErrorModal,
        PageLoading,
        PageHead,
    } from "../../Components/Common/index.svelte";

    import {
        goBack,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";

    import HospitalDetails from "./components/HospitalDetails.svelte";
    import PublicInPrivateDetails from "./components/PublicInPrivateDetails.svelte";
    import NoGapProgramDetails from "./components/NoGapProgramDetails.svelte";
    import { isEnvNewOrApp } from "../../Utils/utilRoute.svelte";

    export let params = {};

    $: showNoGapProgramSection = isEnvNewOrApp() &&
        hospitalDetails && hospitalDetails.isNoGapProgram;

    let isLoadingHospital = false,
        hospitalDetails,
        hospitalPIPData,
        backupHospitalPIPData,
        isPIPEditEnabled = false,
        isUpdatingPIPData = false;

    onMount(async () => {
        if (params.id) loadHospitalById(params.id);
        else goBack();
    });

    const loadHospitalById = async (id) => {
        isLoadingHospital = true;

        await apiMethods.getMethod
            .getHospitalById(id)
            .then((res) => _handleHospital(res));

        isLoadingHospital = false;
    };

    const savePIP = async () => {
        isUpdatingPIPData = true;

        await apiMethods.putMethod
            .updateHospital({ ...hospitalDetails, hospitalPIPData })
            .then((res) => _handleSavePIP(res))
            .catch((err) => showException(err));

        isPIPEditEnabled = false;
        isUpdatingPIPData = false;
    };

    const cancelEdit = () => {
        isPIPEditEnabled = false;
        hospitalPIPData = { ...backupHospitalPIPData };
    };

    // HELPER FUNCTIONS
    const _handleHospital = (res) => {
        if (res.error) showError(res.error, true);
        else {
            hospitalDetails = { ...res };
            if (res.hospitalPIPData) {
                hospitalPIPData = { ...res.hospitalPIPData };
                backupHospitalPIPData = { ...hospitalPIPData };
            }
        }
    };

    const _handleSavePIP = async (res) => {
        if (res.error) showError(res.error);
        else await loadHospitalById(res.id);
    };
</script>

{#if isLoadingHospital}
    <PageLoading />
{:else}
    <PageHead title="View hospital details" />

    <div class="flex-1 relative mt-4">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4">
            <HospitalDetails
                {hospitalDetails}
                reloadHospital={() => loadHospitalById(params.id)}
            />

            <PublicInPrivateDetails
                bind:hospitalPIPData
                bind:isPIPEditEnabled
                bind:isUpdatingPIPData
                on:savePIP={savePIP}
                on:cancelEdit={cancelEdit}
            />

            {#if showNoGapProgramSection}
                <NoGapProgramDetails {hospitalDetails} />
            {/if}
        </div>
    </div>
{/if}
